/**
 * Ryan O'Dowd
 * 2021-07-05
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  const paragraph = {
    display: Platform.OS === 'web' ? 'inline' : 'flex',
    fontSize: globalScale * 16,
    marginBottom: globalScale * 8,
    color: colors.white,
    flexGrow: 1,
  };

  return {
    list: {
      paddingBottom: safeAreaInsets.bottom, // @TODO: would it make sense in the future to make the scollview part of screenwrapper, and this padding is abstracted away?
    },

    otherInfoWrapper: {
      marginBottom: 32,
    },
    questionTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexGrow: 1,
      flexShrink: 1,
    },
    paragraph,
    bold: {
      ...paragraph,
      color: colors.primaryExtraLight,
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
